import { askURL } from "../urls";

const postAsk = async (body) => {
  const token = localStorage.getItem("jwtToken");
  const response = await fetch(askURL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
    redirect: "follow",
  });
  const data = await response.json().catch(() => null);

  if (!response.ok || typeof data !== "string" || !data.trim()) {
    throw new Error(data?.message || "Generation failed");
  }

  return data;
};

export const askChatGPT = (prompt, temperature = 0, max_tokens = 1000) => postAsk({
  prompt,
  temperature,
  max_tokens,
});

export const getGeneratedImage = (size, prompt) => postAsk({
  prompt,
  size,
});
